export type Gender = 'm' | 'w'

type WahlkreisData = {
  [key: string]: {
    firstname: string
    lastname: string
    gender: Gender
  }
}

const wahlkreisData: WahlkreisData = {
  wk1: {
    firstname: 'Johanna',
    lastname: 'Selbert',
    gender: 'w',
  },
  wk2: {
    firstname: 'Truels',
    lastname: 'Reichardt',
    gender: 'm',
  },
  wk3: {
    firstname: 'Hauke',
    lastname: 'Thießen',
    gender: 'm',
  },
  wk4: {
    firstname: 'Felix',
    lastname: 'Wilsberg',
    gender: 'm',
  },
  wk5: {
    firstname: 'Christina',
    lastname: 'Schubert',
    gender: 'w',
  },
  wk6: {
    firstname: 'Kristian',
    lastname: 'Klinck',
    gender: 'm',
  },
  wk7: {
    firstname: 'Dr. Ralf',
    lastname: 'Stegner',
    gender: 'm',
  },
  wk8: {
    firstname: 'Bengt',
    lastname: 'Bergt',
    gender: 'm',
  },
  wk9: {
    firstname: 'Bettina',
    lastname: 'Hagedorn',
    gender: 'w',
  },
  wk10: {
    firstname: 'Dr. Nina',
    lastname: 'Scheer',
    gender: 'w',
  },
  wk11: {
    firstname: 'Tim',
    lastname: 'Klüssendorf',
    gender: 'm',
  },
  wk12: {
    firstname: 'Reem',
    lastname: 'Alabali-Radovan',
    gender: 'w',
  },
  wk13: {
    firstname: 'Frank',
    lastname: 'Junge',
    gender: 'm',
  },
  wk14: {
    firstname: 'Katrin',
    lastname: 'Zschau',
    gender: 'w',
  },
  wk15: {
    firstname: 'Anna',
    lastname: 'Kassautzki',
    gender: 'w',
  },
  wk16: {
    firstname: 'Erik',
    lastname: 'von Malottki',
    gender: 'm',
  },
  wk17: {
    firstname: 'Johannes',
    lastname: 'Arlt',
    gender: 'm',
  },
  wk18: {
    firstname: 'Falko',
    lastname: 'Droßmann',
    gender: 'm',
  },
  wk19: {
    firstname: 'Sören',
    lastname: 'Platten',
    gender: 'm',
  },
  wk20: {
    firstname: 'Wolfgang',
    lastname: 'Schmidt',
    gender: 'm',
  },
  wk21: {
    firstname: 'Dorothee',
    lastname: 'Martin',
    gender: 'w',
  },
  wk22: {
    firstname: 'Aydan',
    lastname: 'Özoğuz',
    gender: 'w',
  },
  wk23: {
    firstname: 'Metin',
    lastname: 'Hakverdi',
    gender: 'm',
  },
  wk24: {
    firstname: 'Johann',
    lastname: 'Saathoff',
    gender: 'm',
  },
  wk25: {
    firstname: 'Anja',
    lastname: 'Troff-Schaffarzyk',
    gender: 'w',
  },
  wk26: {
    firstname: 'Siemtje',
    lastname: 'Möller',
    gender: 'w',
  },
  wk27: {
    firstname: 'Dennis',
    lastname: 'Rohde',
    gender: 'm',
  },
  wk28: {
    firstname: 'Hamza',
    lastname: 'Atilgan',
    gender: 'm',
  },
  wk29: {
    firstname: 'Daniel',
    lastname: 'Schneider',
    gender: 'm',
  },
  wk30: {
    firstname: 'Frauke',
    lastname: 'Langen',
    gender: 'w',
  },
  wk31: {
    firstname: 'Dr. Daniela',
    lastname: 'De Ridder',
    gender: 'w',
  },
  wk32: {
    firstname: 'Alexander',
    lastname: 'Bartz',
    gender: 'm',
  },
  wk33: {
    firstname: 'Peggy',
    lastname: 'Schierenbeck',
    gender: 'w',
  },
  wk34: {
    firstname: 'Özge',
    lastname: 'Kadah',
    gender: 'w',
  },
  wk35: {
    firstname: 'Lars',
    lastname: 'Klingbeil',
    gender: 'm',
  },
  wk36: {
    firstname: 'Svenja',
    lastname: 'Stadler',
    gender: 'w',
  },
  wk37: {
    firstname: 'Jakob',
    lastname: 'Blankenburg',
    gender: 'm',
  },
  wk38: {
    firstname: 'Anke',
    lastname: 'Hennig',
    gender: 'w',
  },
  wk39: {
    firstname: 'Thomas',
    lastname: 'Vaupel',
    gender: 'm',
  },
  wk40: {
    firstname: 'Marja-Liisa',
    lastname: 'Völlers',
    gender: 'w',
  },
  wk41: {
    firstname: 'Adis',
    lastname: 'Ahmetovic',
    gender: 'm',
  },
  wk42: {
    firstname: 'Boris',
    lastname: 'Pistorius',
    gender: 'm',
  },
  wk43: {
    firstname: 'Rebecca',
    lastname: 'Schamber',
    gender: 'w',
  },
  wk44: {
    firstname: 'Angela',
    lastname: 'Hohmann',
    gender: 'w',
  },
  wk45: {
    firstname: 'Hubertus',
    lastname: 'Heil',
    gender: 'm',
  },
  wk46: {
    firstname: 'Johannes',
    lastname: 'Schraps',
    gender: 'm',
  },
  wk47: {
    firstname: 'Dr. Matthias',
    lastname: 'Miersch',
    gender: 'm',
  },
  wk48: {
    firstname: 'Daniela',
    lastname: 'Rump',
    gender: 'w',
  },
  wk49: {
    firstname: 'Dunja',
    lastname: 'Kreiser',
    gender: 'w',
  },
  wk50: {
    firstname: 'Dr. Christos',
    lastname: 'Pantazis',
    gender: 'm',
  },
  wk51: {
    firstname: 'Benjamin',
    lastname: 'Stern',
    gender: 'm',
  },
  wk52: {
    firstname: 'Frauke',
    lastname: 'Heiligenstadt',
    gender: 'w',
  },
  wk53: {
    firstname: 'Dr. Thorsten',
    lastname: 'Heinze',
    gender: 'm',
  },
  wk54: {
    firstname: 'Ulrike',
    lastname: 'Hiller',
    gender: 'w',
  },
  wk56: {
    firstname: 'Wiebke',
    lastname: 'Papenbrock',
    gender: 'w',
  },
  wk57: {
    firstname: 'Stefan',
    lastname: 'Zierke',
    gender: 'm',
  },
  wk58: {
    firstname: 'Ariane',
    lastname: 'Fäscher',
    gender: 'w',
  },
  wk59: {
    firstname: 'Simona',
    lastname: 'Koß',
    gender: 'w',
  },
  wk60: {
    firstname: 'Sonja',
    lastname: 'Eichwede',
    gender: 'w',
  },
  wk61: {
    firstname: 'Olaf',
    lastname: 'Scholz',
    gender: 'm',
  },
  wk62: {
    firstname: 'Anja',
    lastname: 'Soheam',
    gender: 'w',
  },
  wk63: {
    firstname: 'Mathias',
    lastname: 'Papendieck',
    gender: 'm',
  },
  wk64: {
    firstname: 'Maja',
    lastname: 'Wallstein',
    gender: 'w',
  },
  wk65: {
    firstname: 'Hannes',
    lastname: 'Walter',
    gender: 'm',
  },
  wk66: {
    firstname: 'Dr. Herbert',
    lastname: 'Wollmann',
    gender: 'm',
  },
  wk67: {
    firstname: 'Franziska',
    lastname: 'Kersten',
    gender: 'w',
  },
  wk68: {
    firstname: 'Florian',
    lastname: 'Fahrtmann',
    gender: 'm',
  },
  wk69: {
    firstname: 'Martin',
    lastname: 'Kröber',
    gender: 'm',
  },
  wk70: {
    firstname: 'Diana',
    lastname: 'Bäse',
    gender: 'w',
  },
  wk72: {
    firstname: 'Norman',
    lastname: 'Steigleder',
    gender: 'm',
  },
  wk73: {
    firstname: 'Aick',
    lastname: 'Pietschmann',
    gender: 'm',
  },
  wk74: {
    firstname: 'Annika',
    lastname: 'Klose',
    gender: 'w',
  },
  wk75: {
    firstname: 'Alexandra',
    lastname: 'Wend',
    gender: 'w',
  },
  wk76: {
    firstname: 'Julian',
    lastname: 'Holter',
    gender: 'm',
  },
  wk78: {
    firstname: 'Ruppert',
    lastname: 'Stüwe',
    gender: 'm',
  },
  wk79: {
    firstname: 'Michael',
    lastname: 'Müller',
    gender: 'm',
  },
  wk80: {
    firstname: 'Sinem',
    lastname: 'Taşan-Funke',
    gender: 'w',
  },
  wk81: {
    firstname: 'Hakan',
    lastname: 'Demir',
    gender: 'm',
  },
  wk82: {
    firstname: 'Carmen',
    lastname: 'Sinnokrot',
    gender: 'w',
  },
  wk83: {
    firstname: 'Ana-Maria',
    lastname: 'Trăsnea',
    gender: 'w',
  },
  wk84: {
    firstname: 'Ben',
    lastname: 'Schneider',
    gender: 'm',
  },
  wk85: {
    firstname: 'Jan',
    lastname: 'Zimmerling',
    gender: 'm',
  },
  wk86: {
    firstname: 'Ye-One',
    lastname: 'Rhie',
    gender: 'w',
  },
  wk87: {
    firstname: 'Claudia',
    lastname: 'Moll',
    gender: 'w',
  },
  wk88: {
    firstname: 'Christoph',
    lastname: 'Nießen',
    gender: 'm',
  },
  wk89: {
    firstname: 'Daniel',
    lastname: 'Walter',
    gender: 'm',
  },
  wk90: {
    firstname: 'Aaron',
    lastname: 'Spielmanns',
    gender: 'm',
  },
  wk91: {
    firstname: 'Andrea',
    lastname: 'Kanonenberg',
    gender: 'w',
  },
  wk92: {
    firstname: 'Sanae',
    lastname: 'Abdi',
    gender: 'w',
  },
  wk93: {
    firstname: 'Renan',
    lastname: 'Demirkan',
    gender: 'w',
  },
  wk94: {
    firstname: 'Rolf',
    lastname: 'Mützenich',
    gender: 'm',
  },
  wk95: {
    firstname: 'Jessica',
    lastname: 'Rosenthal',
    gender: 'w',
  },
  wk96: {
    firstname: 'Sebastian',
    lastname: 'Hartmann',
    gender: 'm',
  },
  wk97: {
    firstname: 'Ute',
    lastname: 'Krupp',
    gender: 'm',
  },
  wk98: {
    firstname: 'Pascal',
    lastname: 'Reinhardt',
    gender: 'm',
  },
  wk99: {
    firstname: 'Hinrich',
    lastname: 'Schipper',
    gender: 'm',
  },
  wk100: {
    firstname: 'Karl',
    lastname: 'Lauterbach',
    gender: 'm',
  },
  wk101: {
    firstname: 'Helge',
    lastname: 'Lindh',
    gender: 'm',
  },
  wk102: {
    firstname: 'Ingo',
    lastname: 'Schäfer',
    gender: 'm',
  },
  wk103: {
    firstname: 'Pat',
    lastname: 'Kreß',
    gender: 'm',
  },
  wk104: {
    firstname: 'Kerstin',
    lastname: 'Griese',
    gender: 'w',
  },
  wk105: {
    firstname: 'Zanda',
    lastname: 'Martens',
    gender: 'w',
  },
  wk106: {
    firstname: 'Adis',
    lastname: 'Selimi',
    gender: 'm',
  },
  wk107: {
    firstname: 'Daniel',
    lastname: 'Rinkert',
    gender: 'm',
  },
  wk108: {
    firstname: 'Gülistan',
    lastname: 'Yüksel',
    gender: 'w',
  },
  wk109: {
    firstname: 'Ina',
    lastname: 'Spanier-Oppermann',
    gender: 'w',
  },
  wk110: {
    firstname: 'Silke',
    lastname: 'Depta',
    gender: 'w',
  },
  wk111: {
    firstname: 'Bodo',
    lastname: 'Wißen',
    gender: 'm',
  },
  wk112: {
    firstname: 'Kevin',
    lastname: 'Waldeck',
    gender: 'm',
  },
  wk113: {
    firstname: 'Jan',
    lastname: 'Dieren',
    gender: 'm',
  },
  wk114: {
    firstname: 'Bärbel',
    lastname: 'Bas',
    gender: 'w',
  },
  wk115: {
    firstname: 'Mahmut',
    lastname: 'Özdemir',
    gender: 'm',
  },
  wk116: {
    firstname: 'Dirk',
    lastname: 'Vöpel',
    gender: 'm',
  },
  wk117: {
    firstname: 'Sebastian',
    lastname: 'Fiedler',
    gender: 'm',
  },
  wk118: {
    firstname: 'Ingo',
    lastname: 'Vogel',
    gender: 'm',
  },
  wk119: {
    firstname: 'Albert',
    lastname: 'Ritter',
    gender: 'm',
  },
  wk120: {
    firstname: 'Frank',
    lastname: 'Schwabe',
    gender: 'm',
  },
  wk121: {
    firstname: 'Brian',
    lastname: 'Nickholz',
    gender: 'm',
  },
  wk122: {
    firstname: 'Markus',
    lastname: 'Toens',
    gender: 'm',
  },
  wk123: {
    firstname: 'Sarah',
    lastname: 'Lahrkamp',
    gender: 'w',
  },
  wk124: {
    firstname: 'Dustin',
    lastname: 'Tix',
    gender: 'm',
  },
  wk125: {
    firstname: 'Nadine',
    lastname: 'Heselhaus',
    gender: 'w',
  },
  wk126: {
    firstname: 'Johannes',
    lastname: 'Waldmann',
    gender: 'm',
  },
  wk127: {
    firstname: 'Jürgen',
    lastname: 'Coße',
    gender: 'm',
  },
  wk128: {
    firstname: 'Svenja',
    lastname: 'Schulze',
    gender: 'w',
  },
  wk129: {
    firstname: 'Dennis',
    lastname: 'Kocker',
    gender: 'm',
  },
  wk130: {
    firstname: 'Elvan',
    lastname: 'Korkmaz-Emre',
    gender: 'w',
  },
  wk131: {
    firstname: 'Wiebke',
    lastname: 'Esdar',
    gender: 'w',
  },
  wk132: {
    firstname: 'Stefan',
    lastname: 'Schwartze',
    gender: 'm',
  },
  wk133: {
    firstname: 'Fabian',
    lastname: 'Golanowsky',
    gender: 'm',
  },
  wk134: {
    firstname: 'Julien',
    lastname: 'Thiede',
    gender: 'm',
  },
  wk135: {
    firstname: 'Katrin',
    lastname: 'Freiberger',
    gender: 'w',
  },
  wk136: {
    firstname: 'Burkhard',
    lastname: 'Blienert',
    gender: 'm',
  },
  wk137: {
    firstname: 'Timo',
    lastname: 'Schisanowski',
    gender: 'm',
  },
  wk138: {
    firstname: 'Axel',
    lastname: 'Echeverria',
    gender: 'm',
  },
  wk139: {
    firstname: 'Serdar',
    lastname: 'Yüksel',
    gender: 'm',
  },
  wk140: {
    firstname: 'Hendrik',
    lastname: 'Bollmann',
    gender: 'm',
  },
  wk141: {
    firstname: 'Jens',
    lastname: 'Peick',
    gender: 'm',
  },
  wk142: {
    firstname: 'Sabine',
    lastname: 'Poschmann',
    gender: 'w',
  },
  wk143: {
    firstname: 'Oliver',
    lastname: 'Kaczmarek',
    gender: 'm',
  },
  wk144: {
    firstname: 'Michael',
    lastname: 'Thews',
    gender: 'm',
  },
  wk145: {
    firstname: 'Jens',
    lastname: 'Behrens',
    gender: 'm',
  },
  wk146: {
    firstname: 'Dirk',
    lastname: 'Wiese',
    gender: 'm',
  },
  wk147: {
    firstname: 'Luiza',
    lastname: 'Licina-Bode',
    gender: 'm',
  },
  wk148: {
    firstname: 'Nezahat',
    lastname: 'Baradari',
    gender: 'w',
  },
  wk150: {
    firstname: 'Heiko',
    lastname: 'Wittig',
    gender: 'm',
  },
  wk151: {
    firstname: 'Holger',
    lastname: 'Mann',
    gender: 'm',
  },
  wk152: {
    firstname: 'Nadja',
    lastname: 'Sthamer',
    gender: 'w',
  },
  wk153: {
    firstname: 'Franziska',
    lastname: 'Mascheck',
    gender: 'w',
  },
  wk154: {
    firstname: 'Leonhard',
    lastname: 'Weist',
    gender: 'm',
  },
  wk155: {
    firstname: 'Kathrin',
    lastname: 'Michel',
    gender: 'w',
  },
  wk156: {
    firstname: 'Harald',
    lastname: 'Prause-Kosubek',
    gender: 'm',
  },
  wk157: {
    firstname: 'Fabian',
    lastname: 'Funke',
    gender: 'm',
  },
  wk158: {
    firstname: 'Rasha',
    lastname: 'Nasr',
    gender: 'w',
  },
  wk159: {
    firstname: 'Stephan',
    lastname: 'Schumann',
    gender: 'm',
  },
  wk160: {
    firstname: 'Dr. Ralf',
    lastname: 'Walper',
    gender: 'm',
  },
  wk161: {
    firstname: 'Detlef',
    lastname: 'Müller',
    gender: 'm',
  },
  wk162: {
    firstname: 'Carlos',
    lastname: 'Kasper',
    gender: 'm',
  },
  wk163: {
    firstname: 'Dr. Silvio',
    lastname: 'Heider',
    gender: 'm',
  },
  wk164: {
    firstname: 'Jens',
    lastname: 'Juraschka',
    gender: 'm',
  },
  wk165: {
    firstname: 'Maik',
    lastname: 'Linke',
    gender: 'm',
  },
  wk166: {
    firstname: 'Esther',
    lastname: 'Dilcher',
    gender: 'w',
  },
  wk167: {
    firstname: 'Daniel',
    lastname: 'Bettermann',
    gender: 'm',
  },
  wk170: {
    firstname: 'Sören',
    lastname: 'Bartol',
    gender: 'm',
  },
  wk171: {
    firstname: 'Dagmar',
    lastname: 'Schmidt',
    gender: 'w',
  },
  wk172: {
    firstname: 'Felix',
    lastname: 'Döring',
    gender: 'm',
  },
  wk173: {
    firstname: 'Christine',
    lastname: 'Fischer',
    gender: 'w',
  },
  wk174: {
    firstname: 'Michael',
    lastname: 'Neuner',
    gender: 'm',
  },
  wk175: {
    firstname: 'David',
    lastname: 'Wade',
    gender: 'm',
  },
  wk176: {
    firstname: 'Natalie',
    lastname: 'Pawlik',
    gender: 'w',
  },
  wk177: {
    firstname: 'Martin',
    lastname: 'Rabanus',
    gender: 'm',
  },
  wk178: {
    firstname: 'Nadine',
    lastname: 'Ruf',
    gender: 'w',
  },
  wk179: {
    firstname: 'Lennard',
    lastname: 'Oehl',
    gender: 'm',
  },
  wk180: {
    firstname: 'Nancy',
    lastname: 'Faeser',
    gender: 'w',
  },
  wk181: {
    firstname: 'Armand',
    lastname: 'Zorn',
    gender: 'm',
  },
  wk182: {
    firstname: 'Lena',
    lastname: 'Voigt',
    gender: 'w',
  },
  wk183: {
    firstname: 'Melanie',
    lastname: 'Wegling',
    gender: 'w',
  },
  wk184: {
    firstname: 'Helena',
    lastname: 'Wolf',
    gender: 'w',
  },
  wk186: {
    firstname: 'Jens',
    lastname: 'Zimmermann',
    gender: 'm',
  },
  wk187: {
    firstname: 'Sven',
    lastname: 'Wingerter',
    gender: 'm',
  },
  wk188: {
    firstname: 'Mohamed',
    lastname: 'Sayed',
    gender: 'm',
  },
  wk189: {
    firstname: 'Tina',
    lastname: 'Rudolph',
    gender: 'w',
  },
  wk190: {
    firstname: 'Dr. Holger',
    lastname: 'Becker',
    gender: 'm',
  },
  wk191: {
    firstname: 'Florian',
    lastname: 'Wagner',
    gender: 'm',
  },
  wk192: {
    firstname: 'Carsten',
    lastname: 'Schneider',
    gender: 'm',
  },
  wk193: {
    firstname: 'Elisabeth',
    lastname: 'Kaiser',
    gender: 'w',
  },
  wk194: {
    firstname: 'Bastian',
    lastname: 'Dohna',
    gender: 'm',
  },
  wk195: {
    firstname: 'Raimund',
    lastname: 'Meß',
    gender: 'w',
  },
  wk196: {
    firstname: 'Jan',
    lastname: 'Hellinghausen',
    gender: 'm',
  },
  wk197: {
    firstname: 'Dr. Ferdi',
    lastname: 'Akaltin',
    gender: 'm',
  },
  wk198: {
    firstname: 'Dr. Thorsten',
    lastname: 'Rudolph',
    gender: 'm',
  },
  wk199: {
    firstname: 'Umut',
    lastname: 'Kurt',
    gender: 'm',
  },
  wk202: {
    firstname: 'Verena',
    lastname: 'Hubertz',
    gender: 'w',
  },
  wk203: {
    firstname: 'Dr. Tanja',
    lastname: 'Machalet',
    gender: 'w',
  },
  wk204: {
    firstname: 'Daniel',
    lastname: 'Baldy',
    gender: 'm',
  },
  wk205: {
    firstname: 'Markus',
    lastname: 'Trapp',
    gender: 'm',
  },
  wk206: {
    firstname: 'Christian',
    lastname: 'Schreider',
    gender: 'm',
  },
  wk207: {
    firstname: 'Isabel',
    lastname: 'Mackensen-Geis',
    gender: 'w',
  },
  wk208: {
    firstname: 'Matthias',
    lastname: 'Mieves',
    gender: 'm',
  },
  wk209: {
    firstname: 'Angelika',
    lastname: 'Glöckner',
    gender: 'w',
  },
  wk210: {
    firstname: 'Yildiz',
    lastname: 'Härtel',
    gender: 'w',
  },
  wk211: {
    firstname: 'Jürgen',
    lastname: 'Fernengel',
    gender: 'm',
  },
  wk212: {
    firstname: 'Dr. Mohr',
    lastname: 'Marco',
    gender: 'm',
  },
  wk213: {
    firstname: 'Andreas',
    lastname: 'Mehltretter',
    gender: 'm',
  },
  wk214: {
    firstname: 'Michael',
    lastname: 'Schrodi',
    gender: 'm',
  },
  wk215: {
    firstname: 'Nadine',
    lastname: 'Praun',
    gender: 'w',
  },
  wk216: {
    firstname: 'Philippa',
    lastname: 'Sigl-Glöckner',
    gender: 'w',
  },
  wk217: {
    firstname: 'David',
    lastname: 'Rausch',
    gender: 'm',
  },
  wk218: {
    firstname: 'Sebastian',
    lastname: 'Roloff',
    gender: 'm',
  },
  wk219: {
    firstname: 'Seija',
    lastname: 'Knorr-Köning',
    gender: 'w',
  },
  wk220: {
    firstname: 'Korbinian',
    lastname: 'Rüger',
    gender: 'm',
  },
  wk221: {
    firstname: 'Reka',
    lastname: 'Molnar',
    gender: 'w',
  },
  wk222: {
    firstname: 'Raffael',
    lastname: 'Joos',
    gender: 'm',
  },
  wk223: {
    firstname: 'Carmen',
    lastname: 'Wegge',
    gender: 'w',
  },
  wk224: {
    firstname: 'Dr. Bärbel',
    lastname: 'Kofler',
    gender: 'w',
  },
  wk225: {
    firstname: 'Clemens',
    lastname: 'Meikis',
    gender: 'm',
  },
  wk226: {
    firstname: 'Rita',
    lastname: 'Hagl-Kehl',
    gender: 'w',
  },
  wk227: {
    firstname: 'Anja',
    lastname: 'König',
    gender: 'w',
  },
  wk228: {
    firstname: 'Johannes',
    lastname: 'Schätzl',
    gender: 'm',
  },
  wk229: {
    firstname: 'Severin',
    lastname: 'Eder',
    gender: 'm',
  },
  wk230: {
    firstname: 'Marvin',
    lastname: 'Kliem',
    gender: 'm',
  },
  wk231: {
    firstname: 'David',
    lastname: 'Mandrella',
    gender: 'm',
  },
  wk232: {
    firstname: 'Dr. Carolin',
    lastname: 'Wagner',
    gender: 'w',
  },
  wk233: {
    firstname: 'Marianne',
    lastname: 'Schieder',
    gender: 'w',
  },
  wk234: {
    firstname: 'Gregor',
    lastname: 'Forster',
    gender: 'm',
  },
  wk235: {
    firstname: 'Andreas',
    lastname: 'Schwarz',
    gender: 'm',
  },
  wk236: {
    firstname: 'Anette',
    lastname: 'Kramme',
    gender: 'w',
  },
  wk237: {
    firstname: 'Jonas',
    lastname: 'Eckstein',
    gender: 'm',
  },
  wk238: {
    firstname: 'Jörg',
    lastname: 'Nürnberger',
    gender: 'm',
  },
  wk239: {
    firstname: 'Ali-Cemil',
    lastname: 'Sat',
    gender: 'm',
  },
  wk240: {
    firstname: 'Daniel',
    lastname: 'Mirlach',
    gender: 'm',
  },
  wk241: {
    firstname: 'Martina',
    lastname: 'Stamm-Fibich',
    gender: 'w',
  },
  wk242: {
    firstname: 'Carsten',
    lastname: 'Träger',
    gender: 'm',
  },
  wk243: {
    firstname: 'Gabriela',
    lastname: 'Heinrich',
    gender: 'w',
  },
  wk244: {
    firstname: 'Thomas',
    lastname: 'Grämmer',
    gender: 'm',
  },
  wk245: {
    firstname: 'Jan',
    lastname: 'Plobner',
    gender: 'm',
  },
  wk246: {
    firstname: 'Manuel',
    lastname: 'Michniok',
    gender: 'm',
  },
  wk247: {
    firstname: 'Sabine',
    lastname: 'Dittmar',
    gender: 'w',
  },
  wk248: {
    firstname: 'Bernd',
    lastname: 'Rützel',
    gender: 'm',
  },
  wk249: {
    firstname: 'Markus',
    lastname: 'Hümpfer',
    gender: 'm',
  },
  wk250: {
    firstname: 'Katharina',
    lastname: 'Räth',
    gender: 'w',
  },
  wk251: {
    firstname: 'Ulrike',
    lastname: 'Bahr',
    gender: 'w',
  },
  wk252: {
    firstname: 'Heike',
    lastname: 'Heubach',
    gender: 'w',
  },
  wk253: {
    firstname: 'Christoph',
    lastname: 'Schmid',
    gender: 'm',
  },
  wk254: {
    firstname: 'Andreas',
    lastname: 'Büch',
    gender: 'm',
  },
  wk255: {
    firstname: 'Marcel',
    lastname: 'Keller',
    gender: 'm',
  },
  wk256: {
    firstname: 'Konstantin',
    lastname: 'Plappert',
    gender: 'm',
  },
  wk257: {
    firstname: 'Dr. Regina',
    lastname: 'Renner',
    gender: 'w',
  },
  wk258: {
    firstname: 'Lucia',
    lastname: 'Schanbacher',
    gender: 'w',
  },
  wk259: {
    firstname: 'Dietmar',
    lastname: 'Bulat',
    gender: 'm',
  },
  wk260: {
    firstname: 'Jasmina',
    lastname: 'Hostert',
    gender: 'w',
  },
  wk261: {
    firstname: 'Argyri',
    lastname: 'Paraschaki-Schauer',
    gender: 'w',
  },
  wk262: {
    firstname: 'Nils',
    lastname: 'Schmid',
    gender: 'm',
  },
  wk263: {
    firstname: 'Franziska',
    lastname: 'Blessing',
    gender: 'w',
  },
  wk264: {
    firstname: 'Urs',
    lastname: 'Abelein',
    gender: 'm',
  },
  wk265: {
    firstname: 'Macit',
    lastname: 'Karaahmetoglu',
    gender: 'm',
  },
  wk266: {
    firstname: 'Mario',
    lastname: 'Sickinger',
    gender: 'm',
  },
  wk267: {
    firstname: 'Jens',
    lastname: 'Schäfer',
    gender: 'm',
  },
  wk268: {
    firstname: 'Kevin',
    lastname: 'Leiser',
    gender: 'm',
  },
  wk269: {
    firstname: 'Tim-Luka',
    lastname: 'Schwab',
    gender: 'm',
  },
  wk270: {
    firstname: 'Cornelia',
    lastname: 'True',
    gender: 'w',
  },
  wk271: {
    firstname: 'Parsa',
    lastname: 'Marvi',
    gender: 'm',
  },
  wk272: {
    firstname: 'Assad',
    lastname: 'Hussain',
    gender: 'm',
  },
  wk273: {
    firstname: 'Lukas',
    lastname: 'Hornung',
    gender: 'm',
  },
  wk274: {
    firstname: 'Tim',
    lastname: 'Tugendhat',
    gender: 'm',
  },
  wk275: {
    firstname: 'Isabel',
    lastname: 'Cademartori',
    gender: 'w',
  },
  wk276: {
    firstname: 'Philipp',
    lastname: 'Hensinger',
    gender: 'm',
  },
  wk277: {
    firstname: 'Lars',
    lastname: 'Castellucci',
    gender: 'm',
  },
  wk278: {
    firstname: 'Nezaket',
    lastname: 'Yildirim',
    gender: 'w',
  },
  wk279: {
    firstname: 'Katja',
    lastname: 'Mast',
    gender: 'w',
  },
  wk280: {
    firstname: 'Saskia',
    lastname: 'Esken',
    gender: 'w',
  },
  wk281: {
    firstname: 'Dr. Ludwig',
    lastname: 'Striet',
    gender: 'm',
  },
  wk282: {
    firstname: 'Julian',
    lastname: 'Wiedmann',
    gender: 'm',
  },
  wk283: {
    firstname: 'Johannes',
    lastname: 'Fechner',
    gender: 'm',
  },
  wk284: {
    firstname: 'Dirk',
    lastname: 'Flacke',
    gender: 'm',
  },
  wk285: {
    firstname: 'Mirko',
    lastname: 'Witkowski',
    gender: 'm',
  },
  wk286: {
    firstname: 'Derya',
    lastname: 'Türk-Nachbaur',
    gender: 'w',
  },
  wk287: {
    firstname: 'Dr. Lina',
    lastname: 'Seitzl',
    gender: 'm',
  },
  wk288: {
    firstname: 'Rita',
    lastname: 'Schwarzelühr-Sutter',
    gender: 'w',
  },
  wk289: {
    firstname: 'Sebastian',
    lastname: 'Weigle',
    gender: 'm',
  },
  wk290: {
    firstname: 'Florian',
    lastname: 'Zarnetta',
    gender: 'm',
  },
  wk291: {
    firstname: 'Sebastian',
    lastname: 'Gillmeister',
    gender: 'm',
  },
  wk292: {
    firstname: 'Martin',
    lastname: 'Gerster',
    gender: 'm',
  },
  wk293: {
    firstname: 'Leon',
    lastname: 'Hahn',
    gender: 'm',
  },
  wk294: {
    firstname: 'Heike',
    lastname: 'Engelhardt',
    gender: 'w',
  },
  wk295: {
    firstname: 'Robin',
    lastname: 'Mesarosch',
    gender: 'm',
  },
  wk296: {
    firstname: 'Josephine',
    lastname: 'Ortleb',
    gender: 'w',
  },
  wk297: {
    firstname: 'David',
    lastname: 'Maaß',
    gender: 'm',
  },
  wk298: {
    firstname: 'Christian',
    lastname: 'Petry',
    gender: 'm',
  },
  wk299: {
    firstname: 'Esra',
    lastname: 'Limbacher',
    gender: 'm',
  },
}

export default wahlkreisData
